module.exports = __webpack_public_path__ + "static/media/country_fi.b52a4e11.webp";